import React from 'react'
import { useState } from 'react'
import Spinner from './Spinner';

const Login = (props) => {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errormsg, setErrormsg] = useState(false);


  const handleSubmit = async e => {
    e.preventDefault();
    props.setSpinner(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      
      const raw = JSON.stringify({
        "email_id": username,
        "password": password
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "manual"
      };

      await fetch(process.env.REACT_APP_BASE_URL+"/api/support/login", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success === 1) {
            // setUser(result.token)
            //localStorage.setItem('vendorToken', result.token);
            props.setToken(result.token);
            props.setIsLoggedIn(true)
          } else {
            setErrormsg(true)
              
          }
          props.setSpinner(false)
        });

    }
    catch (error) {
      console.log(error);
    }



  }

  return (
    
      <div className="login-page">
        <div className="form">
          <form className="login-form" onSubmit={handleSubmit}>
            <input type="text" placeholder="username" value={username} onChange={({ target }) => {setErrormsg(false); setUsername(target.value)}} />
            <input type="password" placeholder="password" value={password} onChange={({ target }) => setPassword(target.value)} />
            <button>login</button>
            {errormsg ? <p class="message">Invalid Username Or Passwrod</p> : ""}
          </form>
        </div>
      </div>
    

  );
}

export default Login




